<template>
  <div class="box-wrapper">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="scss">
// VARIABLES ARE THE SAME AS THE THEME COLORS IN VUETIFY.JS:
$primary: #f03c0c;
$secondary: #fafafa;
$accent: #14b9d6;
$error: #d0021b;
$warning: #ffc200;
$info: #666666;
$success: #5cb85c;
$black: #000000;
$bloodred: #af371f;
$lightGrey: #d8d8d8;
$darkGrey: #4b4b4b;
// ADDED THIS COLOR FOR BACKGROUND:
$primaryLight: lighten($primary, 35%);

.box-wrapper::before {
  content: "";
  position: fixed;
  left: -55%;
  top: 60%;
  right: 0;
  width: 155%;
  height: 100%;
  background: linear-gradient(155deg, $primaryLight 0%, #fff 100%);
  transform: rotate(15deg);
}
</style>
